import FirmwareVersionsPage from './firmware-versions-page';

export default FirmwareVersionsPage;